enum HttpHeader {
  ACCEPT = 'accept',
  AUTHORIZATION = 'authorization',
  CONTENT_TYPE = 'content-type',
}

export { HttpHeader }
